import * as server from "@/utils/http"

export const _page = params => server.get("/physical-items-log/page", params);

